export const getNextStep = (step) => {
	if (step == 3) return null
	return step + 1
}

export const getInitialStep = () => {
	return 1
}
